import type { LucideIcon } from "lucide-react";
import {
  Activity,
  Award,
  BarChart3,
  Bike,
  ChefHat,
  ClipboardCheck,
  Clock,
  CookingPot,
  Database,
  Donut,
  FileSpreadsheet,
  Flame,
  GlassWater,
  History,
  Home,
  LayoutGrid,
  Link2,
  ListOrdered,
  Megaphone,
  MessageCircle,
  Package,
  PieChart,
  Route,
  Ruler,
  SearchCheck,
  Settings2,
  Smartphone,
  Store,
  Target,
  Timer,
  Trash2,
  Truck,
  Users,
  UtensilsCrossed,
  Wrench,
} from "lucide-react";

export type HeaderNavLink = {
  title: string;
  href: string;
  description: string;
  icon: LucideIcon;
};

export const NAV_META: Record<
  string,
  { description: string; icon: LucideIcon }
> = {
  "/dashboard": {
    description: "Visão geral da operação e indicadores do dia.",
    icon: Home,
  },
  "/painel": {
    description: "Acompanhe pedidos em andamento no kanban.",
    icon: LayoutGrid,
  },
  "/usuarios": {
    description: "Cadastro, papéis e acesso da equipe.",
    icon: Users,
  },
  "/estatisticas": {
    description: "Desempenho e métricas da operação.",
    icon: BarChart3,
  },
  "/relatorios": {
    description: "Lista completa dos relatórios disponíveis.",
    icon: FileSpreadsheet,
  },
  "/relatorios/pizzas-brinde": {
    description: "Volumes e pedidos de pizzas brinde.",
    icon: Award,
  },
  "/relatorios/pizzas-promocoes": {
    description: "Pizzas vendidas em promoção.",
    icon: Megaphone,
  },
  "/relatorios/pedidos-por-bairro": {
    description: "Distribuição de pedidos por bairro.",
    icon: Store,
  },
  "/relatorios/bebidas": {
    description: "Consumo e vendas de bebidas.",
    icon: GlassWater,
  },
  "/relatorios/pizzas-por-sabor": {
    description: "Ranking de sabores mais pedidos.",
    icon: PieChart,
  },
  "/relatorios/pizzas-por-tamanho": {
    description: "Volumes por tamanho de pizza.",
    icon: Ruler,
  },
  "/relatorios/rodizio-pizzas": {
    description: "Movimento do rodízio de pizzas.",
    icon: UtensilsCrossed,
  },
  "/relatorios/salao-pizzas": {
    description: "Pizzas produzidas para o salão.",
    icon: Store,
  },
  "/relatorios/salao-bebidas": {
    description: "Bebidas finalizadas no salão (FoodFly).",
    icon: GlassWater,
  },
  "/pizzaiolo": {
    description: "Tela de produção do pizzaiolo.",
    icon: ChefHat,
  },
  "/pizzaiolo-integracao": {
    description: "Produção integrada com o iFood e parceiros.",
    icon: Link2,
  },
  "/producao-porcoes": {
    description: "Fila e produção de porções.",
    icon: UtensilsCrossed,
  },
  "/producao-bebidas": {
    description: "Fila e produção de bebidas.",
    icon: GlassWater,
  },
  "/forneiro": {
    description: "Controle da operação do forno.",
    icon: Flame,
  },
  "/roterista": {
    description: "Montagem de rotas de entrega.",
    icon: Route,
  },
  "/roterista-automatico": {
    description: "Roteirização automática das entregas.",
    icon: Route,
  },
  "/entregadores": {
    description: "Acompanhamento dos entregadores.",
    icon: Bike,
  },
  "/bordeiro": {
    description: "Produção e controle de bordas.",
    icon: CookingPot,
  },
  "/ranking/painel-bordeiro": {
    description: "Quadro de bordas em tela cheia para a TV da cozinha.",
    icon: ClipboardCheck,
  },
  "/painel-bordeiro": {
    description: "Sugestão diária de bordas, cronômetros e assinatura.",
    icon: ClipboardCheck,
  },
  "/rodizio": {
    description: "Sequência do rodízio no salão.",
    icon: UtensilsCrossed,
  },
  "/rodizio/urgencia": {
    description: "Pedidos urgentes do rodízio.",
    icon: Timer,
  },
  "/ranking/producao": {
    description: "TV de ranking das produções.",
    icon: BarChart3,
  },
  "/ranking/montagem": {
    description: "TV de ranking das montagens.",
    icon: Package,
  },
  "/ranking/entregas": {
    description: "TV de ranking das entregas.",
    icon: Truck,
  },
  "/ranking/retirada": {
    description: "TV de ranking das retiradas.",
    icon: Store,
  },
  "/ranking/ficha-diaria": {
    description: "TV da ficha diária de produção.",
    icon: Timer,
  },
  "/ranking/ficha-setores": {
    description: "TV do progresso e assinatura por setor.",
    icon: ClipboardCheck,
  },
  "/ranking/metas-coletiva": {
    description: "TV das metas coletivas.",
    icon: Target,
  },
  "/ranking/metricas-qualidade": {
    description: "TV das métricas de qualidade.",
    icon: Award,
  },
  "/metas/coletiva": {
    description: "Acompanhe e defina a meta coletiva.",
    icon: Target,
  },
  "/metas/individual": {
    description: "Metas individuais da equipe.",
    icon: ClipboardCheck,
  },
  "/lojas": {
    description: "Cadastro e dados das lojas.",
    icon: Store,
  },
  "/inspecao": {
    description: "Checklist e inspeção das unidades.",
    icon: SearchCheck,
  },
  "/cardapio": {
    description: "Itens e cardápio da operação.",
    icon: UtensilsCrossed,
  },
  "/bordas": {
    description: "Cadastro de bordas.",
    icon: Donut,
  },
  "/tamanhos": {
    description: "Cadastro de tamanhos.",
    icon: Ruler,
  },
  "/filas-integracao": {
    description: "Filas dos pedidos de integração.",
    icon: Link2,
  },
  "/fila-porcoes": {
    description: "Fila de porções em espera.",
    icon: Link2,
  },
  "/fila-bebidas": {
    description: "Fila de bebidas em espera.",
    icon: Link2,
  },
  "/sequencia-pedidos": {
    description: "Sequência dos pedidos do dia.",
    icon: ListOrdered,
  },
  "/aguardando-entrega": {
    description: "Pedidos prontos aguardando saída.",
    icon: Truck,
  },
  "/historicos": {
    description: "Histórico geral da operação.",
    icon: History,
  },
  "/historico-pulo-borda": {
    description: "Histórico de pulos por falta de borda.",
    icon: History,
  },
  "/limpeza-pendentes": {
    description: "Pendentes excluídos da limpeza.",
    icon: Trash2,
  },
  "/whatsapp": {
    description: "Integração e mensagens do WhatsApp.",
    icon: MessageCircle,
  },
  "/controle-producao/und-medida": {
    description: "Unidades de medida da produção.",
    icon: Ruler,
  },
  "/controle-producao/itens": {
    description: "Itens usados na produção.",
    icon: ClipboardCheck,
  },
  "/controle-producao/setores": {
    description: "Setores da linha de produção.",
    icon: Package,
  },
  "/controle-producao/funcionamento": {
    description: "Horários e funcionamento da produção.",
    icon: Clock,
  },
  "/controle-producao/base-semanal": {
    description: "Cadastro da base semanal.",
    icon: Target,
  },
  "/controle-producao/ficha-diaria": {
    description: "Preenchimento da ficha diária.",
    icon: FileSpreadsheet,
  },
  "/controle-producao/ficha-transferencia": {
    description: "Transferência de produção de Birigui para Araçatuba.",
    icon: Truck,
  },
  "/controle-producao/sobras": {
    description: "Sobras de todos os dias da semana.",
    icon: Package,
  },
  "/controle-producao/relatorio-consumo": {
    description: "Consumo de insumos da produção.",
    icon: BarChart3,
  },
  "/controle-producao/relatorio-tempos": {
    description: "Tempos e desempenho da produção.",
    icon: Timer,
  },
  "/controle-producao/relatorio-equipe": {
    description: "Equipe alocada por setor.",
    icon: Users,
  },
  "/perfis/permissoes": {
    description: "Perfis, telas e permissões de acesso.",
    icon: Settings2,
  },
  "/atualizar-apk": {
    description: "Publicar e atualizar o APK do app.",
    icon: Smartphone,
  },
  "/mensagens-mobile": {
    description: "Mensagens enviadas ao aplicativo.",
    icon: Megaphone,
  },
  "/ferramentas-desenvolvedor": {
    description: "Correções e ferramentas em produção.",
    icon: Wrench,
  },
  "/monitoramento": {
    description: "Monitoramento do servidor.",
    icon: Activity,
  },
  "/backups": {
    description: "Dump do Postgres 18 dedicado e cópia neste app.",
    icon: Database,
  },
  "/crons": {
    description: "Agendamentos e crons do servidor.",
    icon: Clock,
  },
};

export function toRichNavLink(item: {
  label: string;
  to: string;
}): HeaderNavLink {
  const meta = NAV_META[item.to];
  return {
    title: item.label,
    href: item.to,
    description: meta?.description ?? "",
    icon: meta?.icon ?? LayoutGrid,
  };
}

export const SISTEMA_MAIN_ITEMS: HeaderNavLink[] = [
  { title: "Dashboard", href: "/dashboard", ...NAV_META["/dashboard"] },
  { title: "Painel", href: "/painel", ...NAV_META["/painel"] },
  { title: "Usuários", href: "/usuarios", ...NAV_META["/usuarios"] },
  { title: "Estatísticas", href: "/estatisticas", ...NAV_META["/estatisticas"] },
];

/** Só no menu lateral — não entra na navbar. */
export const SIDEBAR_ONLY_ITEMS: HeaderNavLink[] = [
  {
    title: "Perfis e permissões",
    href: "/perfis/permissoes",
    ...NAV_META["/perfis/permissoes"],
  },
];
